import { render } from "./ServiceDistributionPage.vue?vue&type=template&id=06e491ae"
import script from "./ServiceDistributionPage.vue?vue&type=script&lang=js"
export * from "./ServiceDistributionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__